import React from 'react';
import { useCertificatesHook } from './useCertificatesHook';
import Datatable from 'material-table';
import { Box } from '@material-ui/core';
import { DownloadIcon, Loader } from '@orijinworks/frontend-commons';

const Certificates = (props) => {
  const { tableOptions, columns, isLoading, certificatesData, setCertificates, handleDownload } = useCertificatesHook(props);

  return (
    <Box width="100%">
      <Loader isLoading={isLoading} />
      <Datatable
        id="certificates-table"
        data={certificatesData}
        columns={columns}
        options={{ ...tableOptions }}
        onSelectionChange={(rows) => setCertificates(rows)}
        actions={[
          {
            tooltip: 'Download Certificates',
            ariaLabel: 'Download Certificates',
            icon: () => <DownloadIcon style={{ color: 'var(--navy-main)' }} />,
            onClick: (evt, data) => handleDownload(evt, data),
          },
        ]}
      />
    </Box>
  );
};

export default Certificates;
